module.exports = __webpack_public_path__ + "static/media/arms-quizz.7fd2287a.jpg";